export const EDIT_CHECKOUT_TREE_QUERY_PARAM = "id";
export const EDIT_CHECKOUT_TREE_QUERY_PARAM_CURRENT_TREE_VALUE = "current";

export const AB_TEST_DETAIL_PAGE_TAB_QUERY_PARAM = "ab-test-detail-page-tab";

export type AbTestDetailPageTab =
  | "overview"
  | "flow-view"
  | `generation-${string}`;

export const AB_TEST_DETAIL_PAGE_TAB = {
  OVERVIEW: "overview" as const,
  FLOW_VIEW: "flow-view" as const,
};

export function isGenerationTab(
  tab: AbTestDetailPageTab,
): tab is `generation-${string}` {
  return tab.startsWith("generation-");
}

export function generationTabSplitId(tab: `generation-${string}`): string {
  return tab.slice("generation-".length);
}

export const CHECKOUT_EXPERIENCE_PAGE_TAB_QUERY_PARAM =
  "checkout-experience-page-tab";

export enum CheckoutExperiencePageTab {
  CHECKOUT_EXPERIENCES = "checkout-experiences",
  CHECKOUT_TREE_LIVE_VIEW = "live-checkout-tree-view",
  ALL_FLOWS = "all-flows",
}
